import { createStore } from 'effector';
import { PortalServicePortalsUsageDto } from '@nx-frontend/shared/types';

export const initialPortalsUsageState: PortalServicePortalsUsageDto = {
  active: 0,
  free: 0,
  limit: 0,
  addonsAllowed: false,
  canManagePortals: false,
  canPurchaseAddons: false,
  subscriptionId: '',
  subscriptionPlanTerm: 'no',
  ltdPaymentPage: false,
  domains: [],
};

export const $portalsUsage = createStore<PortalServicePortalsUsageDto>(initialPortalsUsageState);
